import { Link, Tile, Typography } from "@carrotfertility/carotene-core"
import React from "react"
import { FormattedMessage, useIntl } from "react-intl"
import { useWatch } from "@carrotfertility/carotene-core-x"
import { JourneyTypes } from "#/components/get-reimbursed/steps/ExpenseJourneyTypes"
import { Link as RouterLink } from "react-router-dom"
import { DbgPaths } from "#/utils/Paths"

export function MetabolicCareRequirementsBox({ name }: { name: string }): JSX.Element {
  const value = useWatch({ name })
  const intl = useIntl()

  return value === JourneyTypes.METABOLIC_FERTILITY_HEALTH ? (
    <Tile>
      <Typography variant="h5">
        <FormattedMessage defaultMessage="Care requirements" />
      </Typography>
      <Typography sx={(theme) => ({ marginBlockStart: theme.tokens.spacing.xs })}>
        {intl.formatMessage(
          {
            defaultMessage:
              "This type of care is only eligible when received through the Sprints program. Learn more in your <link>benefit guide</link>."
          },
          {
            link: (linkContent) => (
              <Link
                component={RouterLink}
                to={DbgPaths.METABOLIC_FERTILITY_HEALTH}
                color="inherit"
                target="_blank"
                rel="noopener noreferrer"
              >
                {linkContent}
              </Link>
            )
          }
        )}
      </Typography>
    </Tile>
  ) : null
}
